import { render, staticRenderFns } from "./ShiftBin.vue?vue&type=template&id=981d3e48&scoped=true&"
import script from "./ShiftBin.vue?vue&type=script&lang=ts&"
export * from "./ShiftBin.vue?vue&type=script&lang=ts&"
import style0 from "./ShiftBin.vue?vue&type=style&index=0&id=981d3e48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "981d3e48",
  null
  
)

component.options.__file = "ShiftBin.vue"
export default component.exports